// extracted by mini-css-extract-plugin
export default {"logoContainer":"kVPyu","image":"_9XC7d"};